// extracted by mini-css-extract-plugin
module.exports = {"intro":"GymIntro_intro__2jHfq","intro__title":"GymIntro_intro__title__CXAGh","intro__description":"GymIntro_intro__description__3AdBX"};